import type { FastCleanResultType } from 'reactApp/modules/userQuotaCleaner/sagas/saveFastCleanGroupsSuccess.saga';

/**
 * Соединяет результаты очистки между несколькими попытками
 * - если хотя бы в одной попытке было сейфование – результат тоже говорит, что было
 * - если хотя бы в одной попытке было удалени – результат тоже говорит, что было
 * @param result1 результат первой попытки
 * @param result2 результат второй попытки
 * @returns
 */
export const mergeFastCleanResults = (result1: FastCleanResultType | 'timeout' | '', result2: FastCleanResultType | 'timeout' | '') => {
    if (!result1 || result1 === 'timeout' || result1 === 'unexpected') {
        return result2;
    }
    if (!result2 || result2 === 'timeout' || result2 === 'unexpected') {
        return result1;
    }

    if (result1 === 'remove_and_safe' || result2 === 'remove_and_safe') {
        return 'remove_and_safe';
    }

    if (result1 === 'remove_only' || result2 === 'remove_only') {
        return 'remove_only';
    }

    return 'no_clean';
};
